import { render, staticRenderFns } from "./SendMessageButton.vue?vue&type=template&id=586a4ea6&scoped=true&"
import script from "./SendMessageButton.vue?vue&type=script&lang=js&"
export * from "./SendMessageButton.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageButton.vue?vue&type=style&index=0&id=586a4ea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586a4ea6",
  null
  
)

export default component.exports